export default __webpack_public_path__ + "assets/fonts/fe2e0e4974fe22994e97c660575de3e4.ttf";